(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banniere-defilante"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banniere-defilante')) {
    class BanniereDefilante extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.banniere__track');
        this.slides = Array.from(this.querySelectorAll('.banniere__slide'));
        this.dots = Array.from(this.querySelectorAll('.banniere__dot'));
        this.index = 0;
        this.interval = parseInt(this.dataset.interval || '2000', 10);
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = false;
        this.userPaused = false;
        this.visible = true;
        this.toggle = this.querySelector('.banniere__toggle');
        if (this.toggle && this.slides.length > 1 && !this.reduceMotion && this.interval) {
          this.toggle.hidden = false;
          this.toggle.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.toggle.classList.toggle('is-paused', this.userPaused);
            this.toggle.setAttribute('aria-label', this.userPaused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
            if (!this.userPaused) this.restart();
          });
        }

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            this.goTo(i);
            this.restart();
          });
        });

        this.onScroll = () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.syncIndex(), 80);
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if (this.hasAttribute('data-pause-hover')) {
          this.addEventListener('mouseenter', () => (this.paused = true));
          this.addEventListener('mouseleave', () => (this.paused = false));
        }
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));
        this.track.addEventListener('touchstart', () => (this.paused = true), { passive: true });
        this.track.addEventListener('touchend', () => {
          this.paused = false;
          this.restart();
        }, { passive: true });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
          });
          this.observer.observe(this);
        }

        this.onResize = () => this.goTo(this.index, true);
        window.addEventListener('resize', this.onResize);

        // New Asia (v51) : chargement des bannières 2 et suivantes dès que la 1re image est affichée
        // (ou au chargement complet de la page, au premier glissement du doigt, au premier changement de bannière).
        this.loadDeferred = () => {
          this.querySelectorAll('source[data-srcset]').forEach((el) => {
            el.srcset = el.dataset.srcset;
            el.removeAttribute('data-srcset');
          });
          this.querySelectorAll('img[data-srcset], img[data-src]').forEach((el) => {
            if (el.dataset.srcset) {
              el.srcset = el.dataset.srcset;
              el.removeAttribute('data-srcset');
            }
            if (el.dataset.src) {
              el.src = el.dataset.src;
              el.removeAttribute('data-src');
            }
          });
        };
        const firstImg = this.querySelector('.banniere__slide img');
        if (document.readyState === 'complete' || !firstImg || firstImg.complete) {
          this.loadDeferred();
        } else {
          firstImg.addEventListener('load', this.loadDeferred, { once: true });
          firstImg.addEventListener('error', this.loadDeferred, { once: true });
          window.addEventListener('load', this.loadDeferred, { once: true });
        }
        this.track.addEventListener('touchstart', this.loadDeferred, { once: true, passive: true });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.onResize);
      }

      start() {
        this.stop();
        if (this.slides.length < 2 || this.reduceMotion || !this.interval) return;
        this.timer = setInterval(() => {
          if (!this.paused && !this.userPaused && this.visible && !document.hidden) this.next();
        }, this.interval);
      }

      stop() {
        clearInterval(this.timer);
      }

      restart() {
        this.start();
      }

      next() {
        this.goTo((this.index + 1) % this.slides.length);
      }

      goTo(i, instant) {
        if (i > 0 && this.loadDeferred) this.loadDeferred();
        this.index = i;
        this.track.scrollTo({
          left: i * this.track.clientWidth,
          behavior: instant || this.reduceMotion ? 'auto' : 'smooth',
        });
        this.updateDots();
      }

      syncIndex() {
        const width = this.track.clientWidth || 1;
        const i = Math.round(this.track.scrollLeft / width);
        if (i !== this.index && i >= 0 && i < this.slides.length) {
          this.index = i;
          this.updateDots();
        }
      }

      updateDots() {
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }
    customElements.define('banniere-defilante', BanniereDefilante);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
